import React, { useState, useEffect } from 'react';
import { useHasFocus } from '../../hooks/useHasFocus.js';
import warn from '../../utils/warn.js';
import { visuallyHiddenStyles } from '../VisuallyHidden/VisuallyHidden.js';
import '@indeed/ifl-css';

const useHasHover = hoverElementRef => {
  const [hasHover, setHasHover] = useState(false);
  useEffect(() => {
    const hoverElement = hoverElementRef.current;
    if (!hoverElement) {
      warn("No element found to hover");
      return () => {};
    }
    function handleFocusEvent(ev) {
      setHasHover(ev.type === "mouseover");
    }
    hoverElement.addEventListener("mouseover", handleFocusEvent);
    hoverElement.addEventListener("mouseout", handleFocusEvent);
    return () => {
      if (hoverElement) {
        hoverElement.removeEventListener("mouseover", handleFocusEvent);
        hoverElement.removeEventListener("mouseout", handleFocusEvent);
      }
    };
  }, [hoverElementRef]);
  return hasHover;
};
/**
 * @see https://experience.indeed.design/components/ids/keyboard-focus-only
 */
const KeyboardFocusOnly = props => {
  const {
    children,
    focusElementRef,
    hover = true,
    sx
  } = props;
  const focusElementHasFocus = useHasFocus(focusElementRef);
  const focusElementHasHover = useHasHover(focusElementRef);
  return /*#__PURE__*/React.cloneElement(children, {
    sx: {
      ...children.props.sx,
      ...sx
    },
    style: focusElementHasFocus || hover && focusElementHasHover ? {} : visuallyHiddenStyles
  });
};
KeyboardFocusOnly.displayName = "KeyboardFocusOnly";

export { KeyboardFocusOnly };
